import { useState, useEffect } from "react";

const API_URL =
  "https://core-search.radioplayer.cloud/246/qp/v4/schedule?rpId=192&callback=cb_schedule";

const formatTime = (timestamp) => {
  const date = new Date(timestamp * 1000); // Convert Unix timestamp to milliseconds
  return date.toLocaleTimeString("fi-FI", { hour: "2-digit", minute: "2-digit" });
};

const useNowPlayingData = () => {
  const [nowPlaying, setNowPlaying] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNowPlaying = async () => {
      try {
        const response = await fetch(API_URL);
        const text = await response.text();

        // Strip JSONP function wrapper
        const jsonString = text.replace(/^cb_schedule\(/, "").replace(/\)$/, "");
        const data = JSON.parse(jsonString);

        if (data.results?.now) {
          const now = data.results.now;

          setNowPlaying({
            name: now.programmeName,
            description: now.programmeDescription,
            time: `${formatTime(now.startTime)} - ${formatTime(now.stopTime)}`,
            startTime:now.startTime,
            stopTime:now.stopTime,
            imageUrl: now.imageUrl,
            serviceName: now.serviceName
          });
        }
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchNowPlaying();
  }, []);

  return { nowPlaying, loading, error };
};

export default useNowPlayingData;
